<template>
  <el-card>
    <div
      v-if="$slots.title || $slots.header"
      class="header"
    >
      <h2
        v-if="$slots.title"
        class="title"
      >
        <slot name="title" />
      </h2>

      <slot name="header" />
    </div>

    <slot />
  </el-card>
</template>

<script>
export default {
  name: 'CCard'
}
</script>

<style lang="scss" scoped>
.header {
  @media (min-width: 35rem) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

.title {
  margin: 0 0 0.5em;

  @media (min-width: 35rem) {
    margin: 0.2em 0.5em 0 0;
  }
}
</style>
